declare let THREE: any;

export class WorldToLocalRotationConverter {

  private worldRotation = new THREE.Quaternion();
  private localRotation = new THREE.Quaternion();

  convert(worldEulerRotation, parentObject) {
    this.worldRotation.setFromEuler(worldEulerRotation);
    parentObject.getWorldQuaternion(this.localRotation);
    this.localRotation
      .inverse()
      .multiply(this.worldRotation);
    return this.localRotation;
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Class/WorldToLocalRotationConverter.ts